import logo from "assets/images/logo-bn.png";
import flow from "lodash/flow";
import { Children } from "react";
import { LightButton } from "../../../../components/buttons/buttons";
import Modal from "../../../../components/modals/modal/modal";
import { currencyFormat, nullary } from "../../../../core/utils";
import { ModalProps } from "../../../../core/utils/modals";
import { DatosReferencia } from "../types/pagos.types";
import "./referencia-cep-interbancario.modal.scss";

export type ReferenciaCepInterbancarioModalProps = ModalProps & {
	datos?: Partial<DatosReferencia>
	descargarReferencia: VoidFunction;
};

const ReferenciaCepInterbancarioModal = ({ parent, datos = {}, descargarReferencia }: ReferenciaCepInterbancarioModalProps) => {
	const footer = (close: VoidFunction) => (
		<>
			<LightButton className="me-5" onClick={nullary(flow(descargarReferencia, close))}>Descargar</LightButton>
			<LightButton className="ml-5" onClick={nullary(flow(window.print, close))}>Imprimir</LightButton>
		</>
	);

	return (
		<Modal parent={parent} title="" dialogClassName="referencia-cep-interbancario" footer={footer}>
			<div className="col-12">
				<div className="comprobante-banorte">
					<div className="c-header">
						<img src={logo} alt="alt" height="60px" />
					</div>
					<div className="c-body">
						<div className="c-b-success">
							<div className="e-title">
								<span>Vas a realizar un pago por</span>
							</div>
							<div className="e-subtitle">
								<span>{currencyFormat(datos.importe ?? 0)} MN</span>
							</div>
						</div>
						<div className="row">
							<div className="col-12">
								<table>
									<tbody>
										<tr>
											<td>Cliente:</td>
											<td>{datos.nombre}</td>
										</tr>
										<tr>
											<td>ID de cliente:</td>
											<td>{datos.idCliente}</td>
										</tr>
										<tr>
											<td>Concepto:</td>
											<td>
												{Children.toArray(datos.conceptos?.map(concepto =>
													<>{concepto}<br /></>
												))}
											</td>
										</tr>
										<tr>
											<td>Importe:</td>
											<td>{currencyFormat(datos.importe ?? 0)} MN</td>
										</tr>
									</tbody>
								</table>
								<hr />
								<div className="c-b-success">
									<div className="e-title">
										<span>Captura la siguiente información en tu Banca en Línea.</span>
									</div>
								</div>
								<table>
									<tbody>
										<tr>
											<td>Concepto:</td>
											<td>{datos.referencia}</td>
										</tr>
										<tr>
											<td>Referencia:</td>
											<td>{datos.emisora}</td>
										</tr>
										<tr>
											<td>Cuenta CLABE destino:</td>
											<td>{datos.cuentaDestino}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default ReferenciaCepInterbancarioModal;